import { actionStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsActions";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

actionStyles.scheduleReminderModal = {
    scheduleButtonGridItem: {
        width: [12, 3, 2, 2, 2],
        css: css`
            justify-content: flex-end;
        `,
    },

    scheduleButton: {
        variant: "primary",
        css: css`
            padding: 0 15px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 100%;
                        `,
                    ],
                    "max",
                )}
            span[class^="TypographyStyle"] {
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                font-size: 13px;
                            `,
                            null,
                        ],
                        "minMax",
                    );
                }}
            }
        `,
    },

    startDateGridItem: {
        width: [12, 6, 12, 6, 6],
        css: css`
            padding: 0 0 0 10px;
            flex-direction: column;
            align-items: initial;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            padding: 10px;
                        `,
                        null,
                    ],
                    "minMax",
                );
            }}
            div[class^="react-calendar"] {
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            css`
                                right: unset;
                            `,
                            css`
                                right: unset;
                            `,
                            null,
                            null,
                        ],
                        "minMax",
                    );
                }}
            }
        `,
    },

    endDateGridItem: {
        width: [12, 6, 12, 6, 6],
        css: css`
            padding: 0 0 0 5px;
            flex-direction: column;
            align-items: initial;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            padding: 10px;
                        `,
                        null,
                    ],
                    "minMax",
                );
            }}
            div[class^="react-calendar"] {
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            css`
                                right: unset;
                            `,
                            css`
                                right: unset;
                            `,
                            null,
                            null,
                        ],
                        "minMax",
                    );
                }}
            }
        `,
    },
};
